<script>
import ValueComboBox from './ValueComboBox'

export default {
  name: 'TargetingComboBox',
  components: {
    ValueComboBox
  },
  computed: {
    items() {
      return [
        { value: 'NATIONAL', text: 'National' },
        { value: 'STATE', text: 'Same state' },
        { value: 'CITY', text: 'Same city' },
        { value: 'ZIP', text: 'Same ZIP code' },
        { value: '+1MILE', text: '+1 mi' },
        { value: '+2MILE', text: '+2 mi' },
        { value: '+3MILE', text: '+3 mi' },
        { value: '+4MILE', text: '+4 mi' },
        { value: '+5MILE', text: '+5 mi' }
      ]
    }
  }
}
</script>

<template>
  <value-combo-box @input="$emit('input', $event)" :items="items" label="Targeting" v-bind="$attrs" />
</template>
